import _regeneratorRuntime from "/home/joey/projects/aivitar/talk-to-ai/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/home/joey/projects/aivitar/talk-to-ai/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.math.hypot.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.timers.js";
import { ref } from "vue";
export default {
  name: "VideoComponent",
  setup: function setup() {
    var x = ref(0);
    var y = ref(0);
    var startX = 0;
    var startY = 0;
    var startDrag = function startDrag(event) {
      console.log("drag start");
      startX = event.clientX - x.value;
      startY = event.clientY - y.value;
      document.addEventListener("mousemove", onDrag);
      document.addEventListener("mouseup", endDrag);
    };
    var onDrag = function onDrag(event) {
      x.value = event.clientX - startX;
      y.value = event.clientY - startY;
    };
    var endDrag = function endDrag() {
      document.removeEventListener("mousemove", onDrag);
      document.removeEventListener("mouseup", endDrag);
    };
    return {
      x: x,
      y: y,
      startDrag: startDrag
    };
  },
  mounted: function mounted() {
    var _this = this;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            console.log("<<<<<<<<< CameraAComponent mounted >>>>>>>>>");
            _context.next = 3;
            return _this.getCameraDevices();
          case 3:
            _this.startCamera();
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  onBeforeUnmount: function onBeforeUnmount() {
    this.stopCamera();
  },
  data: function data() {
    return {
      imageWidth: null,
      imageHeight: null,
      videoInterval: null,
      showImageCaptureButton: false,
      videoStream: null,
      currentDeviceId: null,
      devices: []
    };
  },
  methods: {
    closeWindow: function closeWindow() {
      this.stopCapturing();
      this.stopCamera();
      this.$store.commit('updateShowVideo', false);
      this.$store.commit('updatePhoto', null);
    },
    startZoom: function startZoom(event) {
      try {
        this.initialDistance = Math.hypot(event.touches[0].clientX - event.touches[1].clientX, event.touches[0].clientY - event.touches[1].clientY);
      } catch (e) {
        console.error(e);
      }
    },
    zoom: function zoom(event) {
      try {
        var currentDistance = Math.hypot(event.touches[0].clientX - event.touches[1].clientX, event.touches[0].clientY - event.touches[1].clientY);
        var scaleFactor = currentDistance / this.initialDistance;

        // Apply the scale factor to the video element
        this.$refs.videoElement.style.transform = "scale(".concat(scaleFactor, ")");
      } catch (e) {
        console.error(e);
      }
    },
    endZoom: function endZoom() {
      try {
        this.$refs.videoElement.style.transform = "scale(1)";
      } catch (e) {
        console.error(e);
      }
    },
    focusCamera: function focusCamera() {
      try {
        this.$refs.videoElement.requestAutoFocus();
      } catch (e) {
        console.log(e);
      }
    },
    startCamera: function startCamera() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var selectedDeviceId, stream;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              selectedDeviceId = null;
              _this2.$store.commit("updatePhoto", null);

              // Checking if there are multiple devices available
              if (_this2.devices.length > 1) {
                // Selecting the second device, usually the back camera on mobile devices
                if (_this2.devices.length > 2) {
                  console.log("more than 2 devices available");
                  selectedDeviceId = _this2.devices[2].deviceId;
                } else if (_this2.devices.length > 0) {
                  console.log("less than 2 cameras detected");
                  selectedDeviceId = _this2.devices[1].deviceId;
                } else {
                  selectedDeviceId = _this2.devices[0].deviceId;
                }
              }

              // If a second device is available, use it
              if (!selectedDeviceId) {
                _context2.next = 13;
                break;
              }
              console.log("we have selected a device");
              _this2.currentDeviceId = selectedDeviceId;
              _context2.next = 9;
              return navigator.mediaDevices.getUserMedia({
                video: {
                  deviceId: selectedDeviceId
                }
              });
            case 9:
              stream = _context2.sent;
              _this2.$refs.videoElement.srcObject = stream;
              _context2.next = 18;
              break;
            case 13:
              console.log("no selected device");
              // If no second device, fall back to default behavior
              _context2.next = 16;
              return navigator.mediaDevices.getUserMedia({
                video: true
              });
            case 16:
              _this2.stream = _context2.sent;
              _this2.$refs.videoElement.srcObject = _this2.stream;
            case 18:
              _this2.showImageCaptureButton = true;
              _context2.next = 24;
              break;
            case 21:
              _context2.prev = 21;
              _context2.t0 = _context2["catch"](0);
              console.error("Error accessing the camera:", _context2.t0);
            case 24:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[0, 21]]);
      }))();
    },
    clearPhoto: function clearPhoto() {
      this.$store.commit("updateShowVideo", false);
    },
    stopCamera: function stopCamera() {
      if (this.stream) {
        this.stream.getTracks().forEach(function (track) {
          return track.stop();
        });
      }
      this.$refs.videoElement.srcObject = null;
    },
    getCameraDevices: function getCameraDevices() {
      var _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              return _context4.abrupt("return", new Promise( /*#__PURE__*/function () {
                var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(resolve) {
                  var devices;
                  return _regeneratorRuntime().wrap(function _callee3$(_context3) {
                    while (1) switch (_context3.prev = _context3.next) {
                      case 0:
                        _context3.next = 2;
                        return navigator.mediaDevices.enumerateDevices();
                      case 2:
                        devices = _context3.sent;
                        _this3.devices = devices.filter(function (device) {
                          return device.kind === "videoinput";
                        });
                        resolve();
                      case 5:
                      case "end":
                        return _context3.stop();
                    }
                  }, _callee3);
                }));
                return function (_x) {
                  return _ref.apply(this, arguments);
                };
              }()));
            case 1:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    switchCamera: function switchCamera() {
      var _this4 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var nextDeviceId, currentIndex, stream;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              console.log('trying to switch camera');
              _this4.$store.commit('updateActivityLogs', 'trying to switching camera');
              nextDeviceId = null; // If there are multiple devices, find the next device ID
              if (_this4.devices.length > 1) {
                currentIndex = _this4.devices.findIndex(function (device) {
                  return device.deviceId === _this4.currentDeviceId;
                });
                nextDeviceId = currentIndex >= 0 && currentIndex < _this4.devices.length - 1 ? _this4.devices[currentIndex + 1].deviceId : _this4.devices[0].deviceId;
              }
              if (!nextDeviceId) {
                _context5.next = 10;
                break;
              }
              _this4.currentDeviceId = nextDeviceId;
              _context5.next = 8;
              return navigator.mediaDevices.getUserMedia({
                video: {
                  deviceId: nextDeviceId
                }
              });
            case 8:
              stream = _context5.sent;
              _this4.$refs.videoElement.srcObject = stream;
            case 10:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    },
    restartCamera: function restartCamera() {
      this.$store.commit("updatePhotoToApprove", null);
      this.startCamera();
    },
    saveImage: function saveImage() {
      this.$store.commit("updatePhoto", this.$store.state.photoToApprove);
      this.$store.commit("updatePhotoToApprove", null);
    },
    stopCapturing: function stopCapturing() {
      clearInterval(this.videoInterval);
      this.$store.commit("updateIsCapturingVideo", false);
      this.$store.commit("updateShowVideo", false);
    },
    startCapturing: function startCapturing() {
      var _this5 = this;
      if (this.$store.state.isCapturingVideo) {
        this.stopCapturing();
        return;
      }
      this.$store.commit("updateIsCapturingVideo", true);
      this.videoInterval = setInterval(function () {
        console.log('taking frame from video');
        var videoElement = _this5.$refs.videoElement;
        var canvasElement = _this5.$refs.canvasElement;

        // Set the canvas size to the video size
        canvasElement.width = videoElement.videoWidth;
        canvasElement.height = videoElement.videoHeight;
        _this5.imageHeight = videoElement.videoHeight;
        _this5.imageWidth = videoElement.videoWidth;

        // Draw the video frame to the canvas
        var context = canvasElement.getContext("2d");
        context.drawImage(videoElement, 0, 0, canvasElement.width, canvasElement.height);

        // Convert the canvas content to Base64
        var base64Image = canvasElement.toDataURL("image/jpeg", 0.96);
        _this5.$store.commit("addImageFromVideo", base64Image);
      }, this.$store.state.videoFrequencyInMS);
    }
  }
};